document.querySelectorAll('.new-featured-collection').forEach(function (slider) {
  var desktopSlides = parseInt(slider.getAttribute('data-desktop-slides')) || 6;
  var mobileSlides  = parseInt(slider.getAttribute('data-mobile-slides'))  || 2;
  var fixedSlideCounts = slider.getAttribute('data-fixed-slide-counts') === 'true';

  if (fixedSlideCounts) {
    $(slider).slick({
      centerMode: false,
      centerPadding: '0px',
      slidesToShow: desktopSlides,
      slidesToScroll: 1,
      arrows: true,
      dots: false,
      autoplay: false,
      autoplaySpeed: 2500,
      responsive: [
        {
          breakpoint: 768,
          settings: {
            slidesToShow: mobileSlides,
            slidesToScroll: 1,
            arrows: true,
            dots: false,
            centerMode: false,
            centerPadding: '0px'
          }
        }
      ]
    });
  } else {
    $(slider).slick({
      centerMode: true,
      centerPadding: '80px',
      slidesToShow: desktopSlides,
      slidesToScroll: 1,
      arrows: true,
      dots: false,
      autoplay: false,
      autoplaySpeed: 2500,
      responsive: [
        {
          breakpoint: 1400,
          settings: {
            slidesToShow: Math.max(desktopSlides - 1, 1),
            slidesToScroll: 1,
            arrows: true,
            dots: false,
            centerMode: true,
            centerPadding: '80px'
          }
        },
        {
          breakpoint: 1200,
          settings: {
            slidesToShow: Math.max(desktopSlides - 2, 1),
            slidesToScroll: 1,
            arrows: true,
            dots: false,
            centerMode: true,
            centerPadding: '80px'
          }
        },
        {
          breakpoint: 960,
          settings: {
            slidesToShow: Math.max(desktopSlides - 3, 1),
            slidesToScroll: 1,
            arrows: true,
            dots: false,
            centerMode: true,
            centerPadding: '80px'
          }
        },
        {
          breakpoint: 768,
          settings: {
            slidesToShow: mobileSlides,
            slidesToScroll: 1,
            arrows: true,
            dots: false,
            centerMode: true,
            centerPadding: '30px'
          }
        }
      ]
    });
  }
});

document.querySelectorAll('.new-collection').forEach(function (item) {
  item.removeAttribute('aria-describedby');
});
